import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-not-found',
  templateUrl: './event-not-found.component.html',
  styleUrls: ['./event-not-found.component.scss']
})
export class EventNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
